<template>
  <Gallery
    :images="[
      require('@/assets/img/IMG_0079-1200w.jpg'),
      require('@/assets/img/IMG_8024-1200w.jpg'),
      require('@/assets/img/IMG_9056-1200w.jpg'),
      require('@/assets/img/IMG_9824-1200w.jpg'),
      require('@/assets/img/IMG_0045-1200w.jpg'),
    ]"
  />
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'Nature',
  components: {
    Gallery
  }
}
</script>
